var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "现售送货单质检", width: 1200, "footer-hide": true },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    { ref: "deliveryForm", attrs: { "label-position": "top" } },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "定单编号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleOrderRecordCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员名称" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleRecordOwnerName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员电话" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleRecordOwnerPhone,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "送货单编号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "送货总量" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordTotalQuantity,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "送货日期" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateString(
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordDeliveryDate
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "物流公司" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordLogisticsCompanyName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "备注" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordRemark,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单时间" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateTimeString(
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordCreateAt
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单人" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.curSaleDeliveryRecord
                                          .curSaleDeliveryRecordOwnerName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "质检图片" } },
                                [
                                  _c("image-cut", {
                                    attrs: { "button-type": "warning" },
                                    model: {
                                      value: _vm.uploadImageFile,
                                      callback: function ($$v) {
                                        _vm.uploadImageFile = $$v
                                      },
                                      expression: "uploadImageFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c("Table", {
                                ref: "productTable",
                                attrs: {
                                  size: "small",
                                  columns: _vm.productTable.columns,
                                  data: _vm.curSaleDeliveryDetails,
                                  "highlight-row": "",
                                  stripe: "",
                                  border: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        {
                          staticClass: "row-margin-top-10",
                          staticStyle: {
                            "margin-top": "10px",
                            "text-align": "right",
                          },
                          attrs: { gutter: 16 },
                        },
                        [
                          _vm.curSaleDeliveryRecord
                            .curSaleDeliveryRecordDistributionStationCheckStatus ===
                          _vm.CHECK_STATUS_TYPE_UN_CHECK
                            ? _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.onSubmit },
                                    },
                                    [_vm._v("质检提交")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }